import CommonCompareStudiesEvents from "./common/CommonCompareStudiesEvents";

const CompareStudiesPage = () => {
  return <CommonCompareStudiesEvents />;
};

export default CompareStudiesPage;
